import React, { useState } from "react";

const FormSection = ({
  buttonLabel,
  paragraphText,
  inputPlaceholder,
  position,
  section1Name,
  section1Position,
  section2Name,
  section2Position,
  isEditable,
  isEditableSec1,
  isEditableSec2,
  onInputChange,
  onPositionChange,
  onNameSection1,
  onPositionSection1,
  onNameSection2,
  onPositionSection2,
  styles = {},
}) => {
  const defaultStyles = {
    span: {
      display: "flex",
      alignItems: "center",
    },
    button: {
      flexShrink: 0,
      padding: "0 5px",
    },
    paragraph: {
      paddingLeft: "1rem",
      flexGrow: 1,
      margin: 0,
      textAlign: "justify",
    },
    firstContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    secondContainer: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      alignItems: "flex-start",
    },
    inputContainer: {
      width: "48%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    inputLine: {
      border: "none",
      borderBottom: "1px solid #333",
      width: "100%",
      padding: "7px 0px",
    },
    inputName: {
      width: "100%",
      fontWeight: "bold",
      border: "none",
      textAlign: "center",
      margin: "0 0 3px 0",
    },
    inputPosition: {
      width: "100%",
      textAlign: "center",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      textAlign: "center",
      border: "none",
      resize: "none",
    },
    staticName: {
      fontWeight: "bold",
      margin: 0,
      textAlign: "center",
      fontSize: "1rem",
    },
    positionText: {
      margin: 0,
      textAlign: "center",
    },
    dateContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "40%",
      padding: "0px 1.5rem",
    },
    blankDiv: {
      border: "none",
      borderBottom: "1px solid #333",
      width: "100%",
      padding: "7px 0px",
    },
    dateText: {
      margin: 0,
    },
  };
  return (
    <>
      <span style={{ ...defaultStyles.span, ...styles.span }}>
        <div
          className="bg-light border"
          style={{ ...defaultStyles.button, ...styles.button }}
        >
          {buttonLabel}
        </div>
        <p style={{ ...defaultStyles.paragraph, ...styles.paragraph }}>
          {paragraphText}
        </p>
      </span>

      <div
        style={{ ...defaultStyles.firstContainer, ...styles.firstContainer }}
      >
        <div
          style={{
            ...defaultStyles.secondContainer,
            ...styles.secondContainer,
          }}
        >
          <div
            style={{
              ...defaultStyles.inputContainer,
              ...styles.inputContainer,
            }}
          >
            <div
              style={{ ...defaultStyles.inputLine, ...styles.inputLine }}
            ></div>

            {isEditable ? (
              <>
                <input
                  type="text"
                  value={inputPlaceholder}
                  onChange={onInputChange}
                  placeholder="Enter name"
                  style={{ ...defaultStyles.inputName, ...styles.inputName }}
                />
                <textarea
                  type="text"
                  value={position}
                  onChange={onPositionChange}
                  placeholder="Enter position"
                  style={{
                    ...defaultStyles.inputPosition,
                    ...styles.inputPosition,
                  }}
                />
              </>
            ) : (
              <>
                <p
                  style={{ ...defaultStyles.staticName, ...styles.staticName }}
                >
                  {inputPlaceholder}
                </p>
                <p
                  style={{
                    ...defaultStyles.positionText,
                    ...styles.positionText,
                  }}
                >
                  {position}
                </p>
              </>
            )}
            {isEditableSec1 ? (
              <>
                <input
                  type="text"
                  value={section1Name}
                  onChange={onNameSection1}
                  placeholder="Enter name"
                  style={{ ...defaultStyles.inputName, ...styles.inputName }}
                />
                <textarea
                  type="text"
                  value={section1Position}
                  onChange={onPositionSection1}
                  placeholder="Enter position"
                  style={{
                    ...defaultStyles.inputPosition,
                    ...styles.inputPosition,
                  }}
                />
              </>
            ) : (
              <>
                <p
                  style={{ ...defaultStyles.staticName, ...styles.staticName }}
                >
                  {section1Name}
                </p>
                <p
                  style={{
                    ...defaultStyles.positionText,
                    ...styles.positionText,
                  }}
                >
                  {section1Position}
                </p>
              </>
            )}
            {isEditableSec2 ? (
              <>
                <input
                  type="text"
                  value={section2Name}
                  onChange={onNameSection2}
                  placeholder="Enter name"
                  style={{ ...defaultStyles.inputName, ...styles.inputName }}
                />
                <textarea
                  type="text"
                  value={section2Position}
                  onChange={onPositionSection2}
                  placeholder="Enter position"
                  style={{
                    ...defaultStyles.inputPosition,
                    ...styles.inputPosition,
                  }}
                />
              </>
            ) : (
              <>
                <p
                  style={{ ...defaultStyles.staticName, ...styles.staticName }}
                >
                  {section2Name}
                </p>
                <p
                  style={{
                    ...defaultStyles.positionText,
                    ...styles.positionText,
                  }}
                >
                  {section2Position}
                </p>
              </>
            )}
          </div>
          <div
            style={{ ...defaultStyles.dateContainer, ...styles.dateContainer }}
          >
            <div
              className=""
              style={{ ...defaultStyles.blankDiv, ...styles.blankDiv }}
            ></div>
            <p style={{ ...defaultStyles.dateText, ...styles.dateText }}>
              Date
            </p>
          </div>
        </div>
      </div>
      <br />
    </>
  );
};

const FormFooter = ({
  signatories,
  onNameChange,
  onPositionChange,
  fontSize,
  width,
  styles = {}, // Allow external styles
}) => {
  // Default styles
  const defaultContainerStyle = {
    fontSize: fontSize || "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const defaultInnerStyle = {
    overflowX: "auto",
    width: width || "70%",
  };

  const defaultBorderStyle = {
    overflowX: "auto",
  };

  const defaultFlexStyle = {
    minWidth: "600px",
    border: "1px solid black",
  };

  return (
    <div className="" style={{ ...defaultContainerStyle, ...styles.container }}>
      <div style={{ ...defaultInnerStyle, ...styles.inner }}>
        <div
          className="w-100 border"
          style={{ ...defaultBorderStyle, ...styles.border }}
        >
          <div
            className="d-flex flex-row flex-wrap flex-md-nowrap"
            style={{ ...defaultFlexStyle, ...styles.flex }}
          >
            <div className="d-flex flex-column flex-shrink-0 col-12 col-md-6">
              {/* Section 1 */}
              <FormSection
                buttonLabel="A."
                paragraphText="CERTIFIED: Services duly rendered as stated."
                section1Name={signatories?.sectionName_1}
                section1Position={signatories?.sectionPos_1}
                onNameSection1={(e) =>
                  onNameChange("sectionName_1", e.target.value)
                }
                isEditableSec1={true}
                onPositionSection1={(e) =>
                  onPositionChange("sectionPos_1", e.target.value)
                }
                styles={styles}
              />

              {/* Section 2 */}
              <FormSection
                buttonLabel="B."
                paragraphText="CERTIFIED: Supporting documents complete and proper, and cash available in the amount of ₱ 0.00"
                section2Name={signatories?.sectionName_2}
                section2Position={signatories?.sectionPos_2}
                onNameSection2={(e) =>
                  onNameChange("sectionName_2", e.target.value)
                }
                isEditableSec2={true}
                onPositionSection2={(e) =>
                  onPositionChange("sectionPos_2", e.target.value)
                }
                styles={styles}
              />
            </div>

            <div className="d-flex flex-column flex-shrink-0 col-12 col-md-6 border-start border-top">
              {/* Section 3 (Editable Section) */}
              <FormSection
                buttonLabel="C."
                paragraphText="Approved for Payment"
                inputPlaceholder={signatories?.sectionName_3}
                position={signatories?.sectionPos_3}
                isEditable={true}
                onInputChange={(e) =>
                  onNameChange("sectionName_3", e.target.value)
                }
                onPositionChange={(e) =>
                  onPositionChange("sectionPos_3", e.target.value)
                }
                styles={styles}
              />

              {/* Section 4 */}
              <FormSection
                buttonLabel="D."
                paragraphText="CERTIFIED: Each employee whose name appears on the payroll has been paid the amount as indicated opposite his/her name."
                inputPlaceholder={signatories?.sectionName_4}
                position={signatories?.sectionPos_4}
                isEditable={true}
                onInputChange={(e) =>
                  onNameChange("sectionName_4", e.target.value)
                }
                onPositionChange={(e) =>
                  onPositionChange("sectionPos_4", e.target.value)
                }
                styles={styles}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormFooter;
